import React, { useState } from "react";
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Divider,
  ListItemIcon,
  Tooltip,
  Typography,
} from "@mui/material";
import { IRaffle } from "../../store/interfaces/IRaffle";
import { AddAlert, CreditCard, Numbers, Settings, WorkspacePremium, Star, Dashboard, AccountBalance, Person } from "@mui/icons-material";
import { TargetBankAccounts } from "./modules/TargetBankAccounts";
import { General } from "./modules/General";
import { IReportsData } from "../../store/interfaces/IReportsData";

const menuItems = [
  { label: "General", key: "general", premiumConfig: false, inDev: true, icon: <Dashboard /> },
  { label: "Cuentas", key: "accounts", premiumConfig: false, inDev: false, icon: <AccountBalance /> },
  { label: "Compradores", key: "purchasers", premiumConfig: false, inDev: true, icon: <Person /> },
];

interface ReportsMenuProps {
  raffle: IRaffle;
  reportsData: IReportsData;
}

export const ReportsMenu = ({ raffle, reportsData }: ReportsMenuProps) => {
  const [selectedMenu, setSelectedMenu] = useState("accounts");

  return (
    <Box sx={{ display: "flex" }}>
      <Divider />
      <List>
        {menuItems.map((item) => (
          <Tooltip key={item.key} title={item.premiumConfig ? "Funcionalidad Premium" : item.inDev ? "En desarrollo" : ""} placement="right">
            <ListItem disablePadding>
              <ListItemButton
                selected={selectedMenu === item.key}
                disabled={(item.premiumConfig && !raffle.isPremium) || item.inDev}
                onClick={() => setSelectedMenu(item.key)}
                sx={{
                  borderRadius: 1,
                  my: 0.5,
                  "&.Mui-selected": { bgcolor: "primary.main", color: "white" },
                  "&:hover": { bgcolor: "primary.light", color: "white" },
                }}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText sx={{ color: 'black !important' }}>
                  <Typography fontWeight={"bold"} color={selectedMenu === item.key ? "black" : "gray"}>
                    {item.label}
                  </Typography>
                </ListItemText>
                {item.premiumConfig && !raffle.isPremium && <Star sx={{ pl: 1 }}></Star>}
              </ListItemButton>
            </ListItem>
          </Tooltip>
        ))}
      </List>

      <Box sx={{ flexGrow: 1, p: 4 }}>
        {selectedMenu === "general" && <General raffle={raffle} />}
        {selectedMenu === "accounts" && <TargetBankAccounts raffle={raffle} data={reportsData.accountReportData} />}
      </Box>
    </Box>
  );
};

export default ReportsMenu;
